
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, int32_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { filter, sortBy, tryHead } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { comparePrimitives } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export class UpdateImagesDto extends Record {
    constructor(ImageUrl, Position) {
        super();
        this.ImageUrl = ImageUrl;
        this.Position = (Position | 0);
    }
}

export function UpdateImagesDto_$reflection() {
    return record_type("Shared.Image.UpdateImagesDto", [], UpdateImagesDto, () => [["ImageUrl", string_type], ["Position", int32_type]]);
}

export class Image extends Record {
    constructor(Position, ImageUrl) {
        super();
        this.Position = (Position | 0);
        this.ImageUrl = ImageUrl;
    }
}

export function Image_$reflection() {
    return record_type("Shared.Image.Image", [], Image, () => [["Position", int32_type], ["ImageUrl", string_type]]);
}

export function coverImageUrl(imageUrl, images) {
    if (imageUrl !== "") {
        return imageUrl;
    }
    else {
        return defaultArg(map((_arg_1) => _arg_1.ImageUrl, tryHead(sortBy((_arg) => (_arg.Position | 0), filter((image) => (image.ImageUrl !== ""), images), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }))), "");
    }
}

